import type { FaireProductEntity } from "../../entity_types/product";

export const p_4wutf4bd9c: FaireProductEntity = {
  token: "p_4wutf4bd9c",
  type: "product",
  name: "I ❤️ Happy Endings Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/3992f800fd6656d03f5abd14b0bdb9e8a14c7cfb2e4c230ea41eb33e41affb34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/acb8435448da6b77566388999e7c19848e3ac0be70ba0a1cf01a199a41db4c33.jpeg",
    "https://cdn.faire.com/fastly/9ee8d06e55e67a505ef1b10a28e3e12fd0c44cd4fecce2da4a719699a5b5da2e.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5eaebdbd8b3be23e3e31b12fd20f82cb824847d7a09d9972ddcd50e80307a122.jpeg",
    "https://cdn.faire.com/fastly/16daecaf69da2690681f28d00c9b6caf629eab67c158ac81f8aa45e361fb3262.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nThese socks are for the reader who wants plot, passion, and a happy ending—on and off the page. 😉💆📚\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:33:22.934Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
